import { FC, ReactNode } from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import Container from '../../layout/Container.tsx';
import Flex from '../../layout/Flex.tsx';
import CRLogo from '../../../assets/svg-components/CRLogo.tsx';
import { LANDING_URL } from '../../../constants/config.ts';

type Props = {
  className?: string;
  dark?: boolean;
  children?: ReactNode;
  onLogoClick?: () => void;
};

const BaseHeader: FC<Props> = ({ dark, className, children, onLogoClick }) => (
  <div
    className={classNames(
      'transition-all h-[94px] tablet:h-[96px]',
      { 'bg-white': !dark, 'bg-black': dark },
      className,
    )}
  >
    <Container className="py-[24px] !max-w-full">
      <Flex.Wrapper jBetween iCenter>
        <Link to={LANDING_URL} onClick={onLogoClick} target="_blank">
          <CRLogo className={classNames('!w-[163px] !h-[40px]', { 'text-white': dark })} />
        </Link>

        {children}
      </Flex.Wrapper>
    </Container>
  </div>
);

export default BaseHeader;
